const customColorForUI = function () {
  let css = document.getElementById('customCSS');
  const updateCSS = !!css;
  if (!css) {
    css = document.createElement('style');
    css.setAttribute('id', 'customCSS');
  }
  css.type = 'text/css';
  let unavailable = '#c1c1ba';
  const config = JSON.parse(localStorage.getItem('SchedulerConfigurations'));
  let color = config && config.urlHyperlinkColor ? config.urlHyperlinkColor : '#9D001D';
  let hoverColor = config && config.urlHyperlinkColor ? config.urlHyperlinkColor : '#631412';
  css.innerHTML = `.scheduler-text-custom-color { color: ${color} !important; } ` +
    `.ap-checkbox-group .custom-control-input:checked ~ .custom-control-label { color:  ${color} !important; } ` +
    `.scheduler-text-underline-custom-color { border-color: ${color} !important; } ` +
    `.scheduler-button-custom-color {background-color: ${color} !important; border-color: ${color} !important;} ` +
    `.scheduler-button-custom-color:hover {background-color: ${hoverColor} !important; } ` + `.scheduler-button-custom-color.secondary-custom { background-color: #fff !important; color: ${color} !important; border-color: ${color} !important; }` +
    `.scheduler-button-custom-color.scheduler-button-custom-color-for-time-slot:focus{background-color: #fff !important; border-color: ${color} !important; color: ${color} !important; }` +
    `.scheduler-button-custom-color.secondary-custom:hover{background-color: ${color} !important; border-color: ${color} !important; color: #fff !important; }` +
    `.scheduler-button-custom-color.unavailable-custom {background-color: ${unavailable} !important; border-color: ${unavailable} !important;}` +
    `.scheduler-button-custom-color.secondary-2-custom { background-color: #fff !important; color: ${color} !important; border-color: ${color} !important; }` + `.scheduler-checkbox-group-custom .custom-control-input:checked ~ .custom-control-label:before { background-color: ${color} !important; border-color: ${color} !important }` +
    `#Embed { background: ${color} !important; background-color: ${color} !important;}`;
  if (!updateCSS) {
    document.body.appendChild(css);
  }
};

export default {
  customColorForUI: customColorForUI
};



// WEBPACK FOOTER //
// ./src/utils/css-helper.js